'use strict';

var $DateGetTime = require('call-bound')('Date.prototype.getTime');

module.exports = function timeValue(x) {
	return $DateGetTime(x);
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/helpers/timeValue.js
// module id = 848
// module chunks = 231608221292675